import * as React from 'react'
import { graphql } from 'gatsby'

import Page from '../components/Page'
import IndexLayout from '../layouts'
import { Box, Grid, Container } from '@material-ui/core'

interface HeroTemplateProps {
  pageContext: {
    heroName: string
  }
  data: {
    hon: {
      elastic75: {
        search: {
          aggregations: {
            players: {
              per_hero: {
                assists: {
                  value: number
                }
                deaths: {
                  value: number
                }
                experience: {
                  value: number
                }
                gold: {
                  value: number
                }
                herodmg: {
                  value: number
                }
                kills: {
                  value: number
                }
                win_percent: {
                  value: number
                }
                per_player: {
                  buckets: [
                    {
                      key: string
                      doc_count: number
                      assists: {
                        value: number
                      }
                      deaths: {
                        value: number
                      }
                      experience: {
                        value: number
                      }
                      gold: {
                        value: number
                      }
                      herodmg: {
                        value: number
                      }
                      kills: {
                        value: number
                      }
                      win_percent: {
                        value: number
                      }
                      last_games: {
                        hits: {
                          hits: [
                            {
                              _source: {
                                inventory: {
                                  slot_1: string
                                  slot_2: string
                                  slot_3: string
                                  slot_4: string
                                  slot_5: string
                                  slot_6: string
                                }
                              }
                            }
                          ]
                        }
                      }
                    }
                  ]
                }
              }
            }
          }
        }
      }
    }
  }
}

const HeroTemplate: React.SFC<HeroTemplateProps> = props => {
  const heroData = props.data.hon.elastic75.search.aggregations.players.per_hero
  return (
    <IndexLayout>
      <Page>
        <Container>
          <h1>{props.pageContext.heroName}</h1>
          <h2>Top player with 5+ hero games item builds</h2>
          {heroData.per_player.buckets.map(player => {
            return (
              <Box>
                <h3>
                  {player.key} : (Games: {player.doc_count} Win%: {(player.win_percent.value * 100).toFixed(2)})
                </h3>
                {player.last_games.hits.hits.map(game => {
                  const inventory = game._source.inventory
                  if (!inventory) return null
                  return (
                    <Box my={4}>
                      <Grid container spacing={1}>
                        {Object.values(inventory).map(item => {
                          if (!item) return null
                          return (
                            <Grid container item xs={2} spacing={3}>
                              <img height={128} width={128} src={`https://www.heroesofnewerth.com/images/items/${item}.jpg`}></img>
                            </Grid>
                          )
                        })}
                      </Grid>
                    </Box>
                  )
                })}
              </Box>
            )
          })}
        </Container>
      </Page>
    </IndexLayout>
  )
}

export default HeroTemplate

export const query = graphql`
  query HeroInfoResult($elasticQuery: hon_JSON!) {
    hon {
      elastic75 {
        search(index: "matches_new", size: 0, body: $elasticQuery)
      }
    }
  }
`
